import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

const { blue } = colorsPalettes;

export const StyledMonitorBtnWrapper = styled(FlexRow)`
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, ${blue[50]} 100%);
`;
